import React from "react";
import { clinicInfo, treatments } from "../mock/data";
import { Instagram, Phone } from "lucide-react";

export default function Footer() {
  return (
    <footer className="bg-[#0e2b2b] text-white pt-20 pb-8">
      <div className="max-w-[1400px] mx-auto px-6 md:px-8 grid md:grid-cols-2 lg:grid-cols-4 gap-10">
        <div>
          <div className="font-serif-display text-[28px] tracking-wider">DR. KHURANA&rsquo;S</div>
          <div className="text-[10px] tracking-[0.22em] uppercase text-[#5eead4] mt-1">Dental &amp; Aesthetic Clinic</div>
          <p className="mt-4 text-[14px] text-white/60 leading-relaxed max-w-xs">Premium, painless dental care in Chhatameel, Lucknow. Led by Dr. Jaspreet Singh Khurana &amp; Dr. Anshu Singh.</p>
          <div className="mt-6 flex gap-3">
            <a href={clinicInfo.instagram} target="_blank" rel="noreferrer" aria-label="Visit Dr. Khurana's Dental & Aesthetic Clinic on Instagram" className="w-10 h-10 rounded-full border border-white/15 flex items-center justify-center hover:bg-white/10 transition"><Instagram size={16} aria-hidden="true" /></a>
            <a href={`tel:${clinicInfo.phone}`} aria-label={`Call Dr. Khurana's Dental & Aesthetic Clinic at ${clinicInfo.phoneDisplay}`} className="w-10 h-10 rounded-full border border-white/15 flex items-center justify-center hover:bg-white/10 transition"><Phone size={16} aria-hidden="true" /></a>
          </div>
        </div>

        <div>
          <div className="text-[11px] tracking-[0.22em] uppercase text-[#5eead4] font-semibold">Address</div>
          <div className="mt-4 text-[14px] text-white/70 leading-7">
            {clinicInfo.address.line1}<br />
            {clinicInfo.address.line2}<br />
            {clinicInfo.address.line3}<br />
            <span className="text-white/90">{clinicInfo.phone}</span><br />
            <span className="text-white/70">{clinicInfo.instagramHandle}</span>
          </div>
        </div>

        <div>
          <div className="text-[11px] tracking-[0.22em] uppercase text-[#5eead4] font-semibold">Treatments</div>
          <ul className="mt-4 space-y-2">
            {treatments.slice(0, 8).map((t) => (
              <li key={t.title}>
                <a
                  href={t.href || "/#treatments"}
                  className="text-[14px] text-white/70 hover:text-white transition"
                >
                  {t.title}
                </a>
              </li>
            ))}
          </ul>
        </div>

        <div>
          <div className="text-[11px] tracking-[0.22em] uppercase text-[#5eead4] font-semibold">Doctors</div>
          <ul className="mt-4 space-y-2">
            <li><a href="#doctors" className="text-[14px] text-white/70 hover:text-white transition">Dr. Jaspreet Singh Khurana</a></li>
            <li><a href="/periodontist-lucknow/" className="text-[14px] text-white/70 hover:text-white transition">Periodontist in Lucknow</a></li>
            <li><a href="#doctors" className="text-[14px] text-white/70 hover:text-white transition">Dr. Anshu Singh</a></li>
            <li><a href="#about" className="text-[14px] text-white/70 hover:text-white transition">About the Clinic</a></li>
            <li><a href="#contact" className="text-[14px] text-white/70 hover:text-white transition">Book Appointment</a></li>
          </ul>
        </div>
      </div>

      <div className="max-w-[1400px] mx-auto px-6 md:px-8 mt-16 pt-6 border-t border-white/10 flex flex-col md:flex-row items-center justify-between gap-3 text-[12px] text-white/50">
        <div>© {new Date().getFullYear()} Dr. Khurana&rsquo;s Dental &amp; Aesthetic Clinic, Lucknow. All rights reserved.</div>
        <div className="flex items-center gap-4">
          <a href="/privacy" className="hover:text-white transition">Privacy Policy</a>
          <span className="opacity-30">·</span>
          <a href="/terms" className="hover:text-white transition">Terms &amp; Conditions</a>
          <span className="opacity-30">·</span>
          <span>Designed &amp; Developed by Dr. Jaspreet Singh Khurana</span>
        </div>
      </div>
    </footer>
  );
}
